import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, CircleDashed, CloudUpload } from 'lucide-react';
import { useEffect, useState } from 'react';
import { relativeTime } from '../lib/time';
/**
 * Small status chip mirroring Google Docs' "Saving…" / "Saved" indicator.
 * Fed by ONLYOFFICE's onDocumentStateChange events in EditorPage.
 */ export function SaveStatus({ state, lastSavedAt }) {
    // Tick every 30s so "Saved 2 min ago" stays fresh without needing to
    // recompute on every render.
    const [, force] = useState(0);
    useEffect(()=>{
        const t = setInterval(()=>force((n)=>n + 1), 30000);
        return ()=>clearInterval(t);
    }, []);
    if (state === 'saving') {
        return /*#__PURE__*/ _jsxs("span", {
            className: "inline-flex items-center gap-1.5 text-xs text-muted-foreground",
            children: [
                /*#__PURE__*/ _jsx(CloudUpload, {
                    className: "w-3.5 h-3.5 animate-pulse"
                }),
                "Saving…"
            ]
        });
    }
    if (state === 'dirty') {
        return /*#__PURE__*/ _jsxs("span", {
            className: "inline-flex items-center gap-1.5 text-xs text-muted-foreground",
            children: [
                /*#__PURE__*/ _jsx(CircleDashed, {
                    className: "w-3.5 h-3.5"
                }),
                "Unsaved changes"
            ]
        });
    }
    if (state === 'saved' || lastSavedAt) {
        return /*#__PURE__*/ _jsxs("span", {
            className: "inline-flex items-center gap-1.5 text-xs text-muted-foreground",
            children: [
                /*#__PURE__*/ _jsx(Check, {
                    className: "w-3.5 h-3.5 text-green-600"
                }),
                lastSavedAt ? `Saved ${relativeTime(lastSavedAt)}` : 'Saved'
            ]
        });
    }
    return null;
}
